import { useState, useEffect } from 'react';

const useMobileWebview = () => {
  const [isWebview, setWebview] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const isWebViewViaQueryParam = searchParams.get('webview') === 'true';
    const isWebViewViaLocalStorage = window.localStorage.getItem('webview') === 'true';

    setWebview(isWebViewViaQueryParam || isWebViewViaLocalStorage);

    if (isWebViewViaQueryParam && !isWebViewViaLocalStorage) {
      window.localStorage.setItem('webview', 'true');
    }
  }, []);

  useEffect(() => {
    if (!isWebview) return;

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [isWebview]);

  return { isWebview };
};

export default useMobileWebview;

